import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { TicketsDataService } from '../../Services/TicketsDataService';
import { Bar } from 'react-chartjs-2';
import './MonthlyTicketsPage.scss';
import { PageLayout2 } from '../../Components/PageLayout/PageLayout2';
import { InteractionType } from '@azure/msal-browser';

const MonthlyRequestsContent = () => {
    const { instance, accounts } = useMsal();
    const [monthlyData, setMonthlyData] = useState([]);

    useEffect(() => {
        fetchMonthlyStats();
    }, []);

    const fetchMonthlyStats = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0]
            };
            const response = await instance.acquireTokenSilent(request);
            const data = await TicketsDataService.getMonthlyRequestDetails(response.accessToken); // Assuming you have an API method for this
            setMonthlyData(data);
        } catch (error) {
            console.error('Failed to fetch monthly ticket stats:', error);
        }
    };

    const renderCharts = () => {
        return monthlyData.map((monthData, index) => {
            const labels = monthData.dates.map(date => `Day ${date}`);
            const openedData = monthData.opened;
            const closedData = monthData.closed;

            const chartData = {
                labels,
                datasets: [
                    {
                        label: 'Opened Requests',
                        data: openedData,
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 1
                    },
                    {
                        label: 'Closed Requests',
                        data: closedData,
                        backgroundColor: 'rgba(153, 102, 255, 0.2)',
                        borderColor: 'rgba(153, 102, 255, 1)',
                        borderWidth: 1
                    }
                ]
            };

            return (
                <Col key={index} md={4}>
                    <div className="chart-container">
                        <h6>{new Date(monthData.year, monthData.month - 1).toLocaleString('default', { month: 'long' })}</h6>
                        <Bar data={chartData} />
                    </div>
                </Col>
            );
        });
    };

    return (
        <Container fluid className="monthly-requests-page">
            <h5 className="my-4">Monthly Requests</h5>
            <Row>
                {renderCharts()}
            </Row>
        </Container>
    );
};

const MonthlyRequestsPage = () => {
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            <PageLayout2 title="Support Tickets">
                <MonthlyRequestsContent />
            </PageLayout2>
        </MsalAuthenticationTemplate>
    );
};

export default MonthlyRequestsPage;
